var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex justify-between text-white font-bold p-5 bg-medium-purple py-10"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }